import { useEffect } from 'react';

// A panel that owns the screen owns the scrolling under it too: without this a
// drag inside it carries on into the floor, which then sits somewhere else when
// the panel closes. The document is the browser's scroller and <main> is the
// app's own, so both are held for as long as the panel is open. §15
export function useScrollLock(): void {
  useEffect(() => {
    const held: HTMLElement[] = [document.documentElement, document.body];
    const main = document.querySelector<HTMLElement>('main');
    if (main !== null) held.push(main);
    const was = held.map((element) => element.style.overflow);
    for (const element of held) element.style.overflow = 'hidden';
    return () => {
      held.forEach((element, index) => {
        element.style.overflow = was[index] as string;
      });
    };
  }, []);
}
